import getOption from "./getOption.js";
export default (...params) => getOption(true, ...params);
